import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getPlants } from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { useSelectedPlant, useOrganizations } from '..';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to access plants with organization information.
 * @param {boolean} [active] - Filter for active plants
 */
export const usePlants = (active) => {
  const { apiReady } = useApiReady();
  const { selectedPlant } = useAppContext();
  const { setSelectedPlant } = useSelectedPlant();
  const { data: organizations } = useOrganizations();

  return useQuery({
    queryKey: [QUERY_KEYS.PLANT_DATA, { active }, setSelectedPlant, selectedPlant],
    queryFn: async () => {
      const plants = await getPlants(active ? { active } : undefined);

      // If no data is returned or the selected plant is not found, reset the selected plant
      if (!plants?.length || !plants?.find((plant) => plant.id === selectedPlant)) setSelectedPlant('');

      return plants;
    },
    select: (plants) =>
      plants.map((plant) => ({
        ...plant,
        organizationName: organizations?.find((org) => org.organizationId === plant.organizationId)?.description || '',
      })),
    staleTime: Infinity,
    enabled: Boolean(apiReady && organizations),
  });
};
